module.exports = __webpack_public_path__ + "img/datacenter_cardbg.f162f5e2.png";